export default __webpack_public_path__ + "static/wamo_big-967b7dc22252e3c8dd46f853a594e4d6.mp4";